<div class="container">

  <!-- ======================= MOBILE VIEW ======================= -->
  @if (isMobile$ | async) {
  <div class="mobile">
    <!-- Search and Filter Section (Hidden on Desktop) -->
    <div class="search-filter-container">
      <div class="search-input">
        <input
          type="text"
          pInputText
          placeholder="Search vehicle name or chassis number" 
          [formControl]="searchTermControl"
        />
      </div>
      <button class="sort-btn" (click)="toggleSortOrder()">
        <span class="material-symbols-outlined">sort_by_alpha</span>
      </button>
    </div>

    <!-- Banned Icons Defenitions Section (Hidden on Desktop) -->
    <div class="icon-explenation"> 
      <div class="icon-row"> 
        <img src="assets/icons/banPublicRoad.png" alt="Public Road" class="icon" width="24" height="24" />
        <span>Banned for Public Road</span>
      </div>

      <div class="icon-row"> 
        <img src="assets/icons/banTestTrack.png" alt="Test Track" class="icon" width="24" height="24" />
        <span> Banned for Test Track </span>
      </div>
    </div>

    <!-- Mobile Vehicle Cards [ngClass]="{'selected-card': item.selected}"-->
    @for (vehicle of filteredAndSortedVehicles$ | async; track vehicle.name) {
      <div class="restriction-card">
        <p-card class="custom-card">
          <div class="card-content">
            <div class="left-content">
              <div class="card-header">
                <div class="card-title"><strong></strong> {{ vehicle.name }} </div>
                <div class="header-right">
                  @let status = getVehicleRestrictionStatusClass(vehicle);
                  @if (status === 'no-ban') {
                    <div class="status-badge no-ban">R&D-staff</div>
                  } @else if (status === 'one-ban') {
                    <div class="status-badge one-ban">Restricted</div>
                  } @else if (status === 'two-bans') {
                    <div class="status-badge two-bans">Driving ban</div>
                  }
                  <p-popover #op [style]="{ width: '240px', maxWidth: '90vw' }">
                    <ng-template pTemplate="content">
                      <h3>Additional Information</h3>
                      <div [innerHTML]="getVehicleCommentsHtml(vehicle)" style="font-size: 16px;"></div>
                    </ng-template>
                  </p-popover>
                  <p-button
                    (click)="op.toggle($event)" 
                    icon="pi pi-info-circle" 
                    styleClass="rounded-info-button p-button-rounded p-button-text"
                  ></p-button>
                </div>
              </div>
              <div class="restriction-list">
                @for (restriction of vehicle.restrictions; track restriction.restrictionName) {
                  <div class="restriction-row">
                    <span class="icons">
                      @if (restriction.banPublicRoad) {
                        <img src="assets/icons/banPublicRoad.png" alt="Public Road" class="icon" width="24" height="24" />
                      } @else {
                        <img src="assets/icons/banPublicRoadMuted.png" alt="Public Road" class="icon" width="24" height="24" />
                      }
                      @if (restriction.banTestTrack) {
                        <img src="assets/icons/banTestTrack.png" alt="Test Track" class="icon" width="24" height="24" />
                      } @else {
                        <img src="assets/icons/banTestTrackMuted.png" alt="Test Track" class="icon" width="24" height="24" />
                      }
                    </span>
                    <span class="subheader">
                      {{ restriction.restrictionName }}
                    </span>
                  </div>
                }
              </div>
            </div>
          </div>
          <div class="button-container">
            <div class="grow-button">
              <p-button 
                label="Open"
                icon="pi pi-chevron-right"
                iconPos="right" 
                (onClick)="goVehicle(vehicle.name)"
              ></p-button>
            </div>
          </div>
        </p-card>
      </div>
    }
  </div><!-- .mobile -->
  } @else {
  <!-- ======================= DESKTOP VIEW ======================= -->
  <div class="desktop">
    @if (rows$ | async; as data) {
      <p-table
        [value]="data"
        rowGroupMode="rowspan"
        groupRowsBy="vehicleName"
        sortMode="single"
        sortField="vehicleName"
        dataKey="vehicleName"
        [paginator]="true"
        [rows]="rowsPerPage"
        [rowsPerPageOptions]="[10,15,25,50]"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [tableStyle]="{ 'min-width': '70rem' }"
      >
        <ng-template pTemplate="caption">
          <div class="flex justify-content-end">
            <p-iconfield iconPosition="left">
              <p-inputicon><i class="pi pi-search"></i></p-inputicon>
              <input pInputText #q (input)="onGlobalFilter(q.value)" placeholder="Search keyword" />
            </p-iconfield>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="vehicleName">
              Vehicle Name <p-sortIcon field="vehicleName" />
            </th>
            <th>Restriction ID</th>
            <th>Restriction Name</th>
            <th>Created Date</th>
            <th>Updated Date</th>
            <th >Valid To</th>
            <th>Responsible</th>
            <th>BAN</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-rowgroup="rowgroup" let-rowspan="rowspan">
          <tr
            class="clickable-row"
            (click)="goVehicle(row.vehicleName)">
            @if (rowgroup) {
              <td
                [attr.rowspan]="rowspan"
                class="vehicle-name">
                <strong>{{ row.vehicleName }}</strong>
                <i class="pi pi-chevron-right open-hint-icon"></i>
              </td>
            }
            <td>{{ row.displayName }}</td>
            <td>{{ row.restrictionName }}</td>
            <td>{{ row.dateCreated | date:'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ row.dateUpdated | date:'yyyy-MM-dd HH:mm' }}</td>
            <td>{{ row.validTo | date:'yyyy-MM-dd' }}</td>
            <td>{{ row.responsible }}</td>
            <td>
              @if (row.banPublicRoad) { Public Road }
              @if (row.banPublicRoad && row.banTestTrack) { , }
              @if (row.banTestTrack) { Test Track }
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div><!-- .desktop -->
  }
</div><!-- .container -->




